import { categorias } from "@/mocks/products";
import type { Produto } from "@/mocks/products";

interface ProductCardProps {
  produto: Produto;
  onSelect: (produto: Produto) => void;
}

export default function ProductCard({ produto, onSelect }: ProductCardProps) {
  const categoria = categorias.find((c) => c.slug === produto.categoria)?.nome ?? "";

  return (
    <button
      type="button"
      onClick={() => onSelect(produto)}
      className="group block w-full cursor-pointer text-left"
      aria-label={`Ver produto ${produto.nome}`}
    >
      <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={produto.imagem}
          alt={produto.nome}
          title={`${produto.nome} — Ocean Companhia de Comércio`}
          className="h-full w-full object-cover object-top transition-transform duration-700 ease-editorial group-hover:scale-[1.04]"
        />
        <span className="pointer-events-none absolute inset-0 rounded-lg border border-transparent transition-colors duration-500 group-hover:border-accent-400/70" />
      </div>

      <p className="ocean-label mt-4 text-[9px] text-accent-600 md:text-[10px]">{categoria}</p>
      <h3 className="mt-2 font-heading text-lg font-medium leading-snug text-foreground-950 md:text-xl">
        {produto.nome}
      </h3>
      <span className="mt-2 inline-flex items-center gap-1.5 text-xs text-foreground-500 transition-colors duration-300 group-hover:text-accent-600">
        Ver produto
        <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
      </span>
    </button>
  );
}